var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-124"},[_c('div',{staticClass:"overlap-group-6"},[_c('p',{staticClass:"address-1 blogtextbold"},[_c('span',{staticClass:"span-9 blogtextbold"},[_vm._v(_vm._s(_vm.spanText1))]),_c('br'),_c('br'),_c('span',{staticClass:"textcourantsmall"},[_vm._v(_vm._s(_vm.spanText2))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }